
import { IJob, ISort } from '@/store/state';
import axios from 'axios';
import qs from 'query-string';

const headers = {
	'X-Requested-With': 'XMLHttpRequest',
	'Accept': 'application/json',
}

export interface ISearchParams {
    query: string;
    categories: any[],
    page: number,
    sort: ISort
}

interface ISearchReturnObject {
    jobs: IJob[],
    total: number,
}   

// Used in searchAction (in actions.ts)
export const search = (searchURL: string, params: ISearchParams): Promise<ISearchReturnObject> => {
    let url = `${searchURL}&${qs.stringify({
        query: params.query || '*',
        categories: JSON.stringify(params.categories),
        page: params.page,
        sort: JSON.stringify(params.sort)

    })}`

    return axios.get(url, { headers })
        .then((response:any) => {
            return response.data
        })
        .catch((searchError:any) => {
            console.error({
                searchError
            })
            return {} as ISearchReturnObject
        })
}
